import StoresTable from './StoresTable';

export default StoresTable;
